import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBag, User, Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/shop", label: "Shop all" },
  { to: "/shop?category=Trending", label: "Trending" },
];

export function Nav() {
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const [menu, setMenu] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-[var(--line)]/70 bg-[var(--bone)]/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 md:h-20 md:px-10">
        <Link to="/" data-testid="nav-logo" onClick={() => setMenu(false)}><Logo /></Link>
        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <NavLink key={l.label} to={l.to} className="link-u text-sm font-medium" data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}>{l.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          {user?.role === "admin" && (
            <Link to="/admin" className="hidden rounded-full border border-[var(--ink)] px-4 py-2 text-xs font-semibold md:inline-flex" data-testid="nav-admin-link">Dashboard</Link>
          )}
          <Link to="/account" className="grid h-11 w-11 place-items-center rounded-full transition-colors hover:bg-[var(--sand)]" aria-label="Account" data-testid="nav-account-link"><User size={20} /></Link>
          <button onClick={() => setOpen(true)} className="relative flex h-11 items-center gap-2 rounded-full bg-[var(--ink)] px-4 text-[var(--bone)] transition-transform hover:scale-[1.04] active:scale-95" data-testid="nav-cart-button">
            <ShoppingBag size={18} />
            <motion.span key={count} initial={{ y: -8, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="text-sm font-semibold" data-testid="nav-cart-count">{count}</motion.span>
          </button>
          <button className="grid h-11 w-11 place-items-center lg:hidden" onClick={() => setMenu((m) => !m)} aria-label="Menu" data-testid="nav-mobile-menu-button">
            {menu ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {menu && (
        <motion.nav initial={{ height: 0 }} animate={{ height: "auto" }} className="overflow-hidden border-t border-[var(--line)] lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col px-5 py-4">
            {links.map((l) => (
              <Link key={l.label} to={l.to} onClick={() => setMenu(false)} className="font-display border-b border-[var(--line)] py-4 text-3xl last:border-0">{l.label}</Link>
            ))}
            {user?.role === "admin" && <Link to="/admin" onClick={() => setMenu(false)} className="py-4 text-lg font-semibold text-[var(--terra-deep)]">Admin dashboard</Link>}
          </div>
        </motion.nav>
      )}
    </header>
  );
}
